import { object, string } from 'zod';

import { makeZodValidate as makeValidate } from '@occc/ui-forms';
import { IS_REQUIRED, IS_VALID } from '@occc-app/lib/constants/validationMessages';
import { validatePhoneNumber } from '@occc/utils-phone-number';

const retailerNetworkUserUpdateSchema = object({
  firstName: string({ required_error: IS_REQUIRED }),
  lastName: string({ required_error: IS_REQUIRED }),
  phoneNumber: string().nullable().refine(validatePhoneNumber, { message: IS_VALID }).optional(),
  email: string({ required_error: IS_REQUIRED }).email(),
});

export const validateRetailerNetworkUserUpdate = makeValidate(retailerNetworkUserUpdateSchema);
